import axios from './axios'
import { Patient, VacciniTable } from '@/../../EshJSLib/models/patient'
import { TblTerapie, AdverseReactions } from '@/../../EshJSLib/models/patient'
import { Farmaci } from '@/../../EshJSLib/models/farmaciModel'

export async function saveAdverseReaction(params: AdverseReactions) {

    const json = JSON.stringify(params);
    const response = await axios.post(`/api/adverseReaction`, json);
    console.log(response.data);
    return response.data;
}

export async function saveTerapia(params: TblTerapie) {

    let  response ={} as any;

    const json = JSON.stringify(params);


        response =  await axios.post(`/api/farmaci`, json).catch((error) => {
        throw error
        })



     return response;
}

export async function filterFarmaci(param: String): Promise<Farmaci[]> {


    const json = JSON.stringify({search: param });
    const response = await axios.post(`/api/farmacifilter`, json);
    return response.data.data as Farmaci[];
}

export async function filterFarmaciVaccini(param: String): Promise<Farmaci[]> {

    const json = JSON.stringify({search: param });
    const response = await axios.post(`/api/farmaciVacciniFilter`, json);
    return response.data.data as Farmaci[];
}



export async function getFarmaci( idp: Number, tipo: Number) {


    const response = await axios.get(`/api/getFarmaci/${tipo}/${idp}`);
    return response.data.data as TblTerapie[];
}

export async function getAdverseReaction() {


   const response = await axios.get(`/api/getAdverseReaction`);
   console.log(response.data.data);
   return response.data;
}

export async function fetchSecuritySettings() {
    try {
        const response = await axios.get(`/api/fetchSecuritySettings`);
        return response.data;
    } catch (error) {
       console.error('Error fetching security settings:', error);
        throw error;
    }
}

export async function deleteFarmaci(id: Number) {
    const response = await axios.delete(`/api/farmaci/${id}`);
    return response.data;
}

export async function checkFarmaco(idFarmaco) {
    try {
        const response = await axios.get(`/api/checkFarmaco/${idFarmaco}`);
        return response.data;
    } catch (error) {
        console.error('Errore durante il controllo del farmaco:', error);
        throw error;
    }
}

export async function checkInterazioniFarmaco(idFarmaco) {
    try {
        const response = await axios.get(`/api/checkInterazioniFarmaco/${idFarmaco}`);
        return response.data;
    } catch (error) {
        console.error('Errore durante il controllo delle interazioni:', error);
        throw error;
    }
}